import { render, staticRenderFns } from "./GridBodyNoRecord.vue?vue&type=template&id=8a824148&scoped=true&"
import script from "./GridBodyNoRecord.vue?vue&type=script&lang=js&"
export * from "./GridBodyNoRecord.vue?vue&type=script&lang=js&"
import style0 from "./GridBodyNoRecord.vue?vue&type=style&index=0&id=8a824148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a824148",
  null
  
)

export default component.exports